import AsyncStorage from "@react-native-async-storage/async-storage";
import { CipherService } from "../../shared/services/CipherService";

export const Storage = {
  async get(key: string) {
    const encryptedValue = await CipherService.get(key);
    if (encryptedValue) {
      return encryptedValue;
    }

    const legacyValue = await AsyncStorage.getItem(key);
    if (legacyValue != null) {
      await CipherService.set(key, legacyValue);
      await AsyncStorage.removeItem(key);
      return legacyValue;
    }

    return null;
  },

  async set(key: string, value: string) {
    await CipherService.set(key, value);
    await AsyncStorage.removeItem(key);
  },

  async remove(key: string) {
    await Promise.all([CipherService.remove(key), AsyncStorage.removeItem(key)]);
  },

  async clearAll() {
    await Promise.all([CipherService.clear(), AsyncStorage.clear()]);
  },
};
